// Polyfill for structuredClone, used by Chakra UI v3 (use-recipe) internals.
// structuredClone is a 2022+ global (Firefox 94+, Chrome 98+); the older
// Firefox/ESR build used in the IVV environment doesn't provide it, so the
// app crashes there while working in INT. Chakra only clones plain
// JSON-serialisable recipe-config objects, so a JSON round-trip suffices.
// Imported first in index.js so it runs before any Chakra code executes.
if (typeof window.structuredClone !== 'function') {
  window.structuredClone = (value) =>
    value === undefined ? undefined : JSON.parse(JSON.stringify(value));
}
